var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-sm-12" },
      [
        _c("header-list", {
          attrs: {
            title: _vm.pageTitle,
            placeholderSearch: _vm.searchPlaceholder,
            routeAddName: _vm.finalRouteAddName,
            canAdd: _vm.canAdd,
            addTitle: _vm.addTitle,
            canConfig: _vm.canConfig,
            routeConfigName: _vm.finalRouteConfigName,
            configTitle: _vm.headerConfigTitle,
          },
          on: { search: _vm.onSearch },
          model: {
            value: _vm.query,
            callback: function ($$v) {
              _vm.query = $$v
            },
            expression: "query",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { attrs: { id: "accordion" } },
              _vm._l(_vm.lists.header, function (item, idx) {
                return _c(
                  "div",
                  { key: `item-${idx}`, staticClass: "card accordion" },
                  [
                    _c("div", { staticClass: "card-header" }, [
                      _c("div", { staticClass: "row no-gutters" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col",
                            attrs: {
                              id: "heading" + item.id,
                              "data-toggle": "collapse",
                              "data-target": "#collapse" + item.id,
                              "aria-expanded": _vm.expandId == item.id,
                              "aria-controls": "collapse" + item.id,
                            },
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(item.name) +
                                "\n                                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "collapse",
                        class: { show: _vm.expandId == item.id },
                        attrs: {
                          id: "collapse" + item.id,
                          "aria-labelledby": "heading" + item.id,
                          "data-parent": "#accordion",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _c("table-data", {
                              attrs: {
                                showTitleData: false,
                                data: item.automatic
                                  ? _vm.automatic
                                  : _vm.manuals,
                                settings: _vm.table.settings,
                                columns: _vm.tableColumns,
                                inlineFilters: _vm.table.filters,
                                autoUpdateFilter: _vm.table.autoUpdateFilter,
                                addParamsToUrl: _vm.table.addParamsToUrl,
                                loadingMsg: _vm.table.loadingMsg,
                                notFoundMsg: _vm.table.notFoundMsg,
                                orderByTemplate: _vm.table.orderByTemplate,
                                showPagination: _vm.table.showPagination,
                                tableInline: _vm.table.tableInline,
                                tableClass: "table-responsive-sm",
                              },
                              on: { "error-load": _vm.showError },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "body",
                                    fn: function ({
                                      columns,
                                      row,
                                      index,
                                      remove,
                                    }) {
                                      return [
                                        _vm._l(columns, function (column, idx) {
                                          return column.field ||
                                            column.field_label
                                            ? _c(
                                                "td",
                                                {
                                                  key: `row-${row.id}-column-${idx}`,
                                                  class: [
                                                    column.class,
                                                    {
                                                      "tbl-column-disabled":
                                                        !!!row.status,
                                                    },
                                                  ],
                                                },
                                                [
                                                  column.field == "targets"
                                                    ? [
                                                        _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "list-circle m-0 pl-3",
                                                          },
                                                          _vm._l(
                                                            row[column.field],
                                                            function (child) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  key: `target-${child.id}`,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.columnValue(
                                                                          child,
                                                                          column
                                                                        )
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              _vm.columnValue(
                                                                row,
                                                                column
                                                              )
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ],
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        }),
                                        _vm._v(" "),
                                        _vm.checkActions
                                          ? _c("column-actions", {
                                              attrs: {
                                                routeEdit: `${_vm.moduleCode}.${_vm.pageID}.show`,
                                                label: "subject",
                                                canDetail: _vm.canDetail,
                                                canEdit: _vm.canEdit,
                                                canDelete: _vm.canDelete,
                                                row: row,
                                                index: index,
                                                callbackDelete: remove,
                                              },
                                              on: { delete: _vm.deleteItem },
                                            })
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }